/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import PageHeaderCustomComponent from "../../../../components/PagesComponents/Organizational/Management/Staffs/PageHeaderCustomComponent.component";
import StaffsHeadCard from "../../../../components/PagesComponents/UniversalComponents/StaffsHeadCard.component";
import TestProfileImage from "../../../../assets/Images/TestImg/profileImage.png";
import MemberListCard from "../../../../components/PagesComponents/Organizational/Management/Members/MemberListCard.component";
import profileImg from "../../../../assets/Images/TestImg/profileImage.png";
import SelectFilter from "../../../../components/PagesComponents/UniversalComponents/SelectFilter.component";
import PieChartComponent from "../../../../components/PagesComponents/Organizational/Management/Staffs/PieChart";
import Modal from "../../../../components/Universal/Modal.component";
import { Formik } from "formik";
import DropDownInput from "../../../../components/Universal/DropDownInput.component";
import FileInput from "../../../../components/PagesComponents/Organizational/Management/Members/FileInput.component";
import ToggleBtn from "../../../../components/Universal/ToggleBtn.component";
import DatePicker from "../../../../components/Universal/DatePicker.component";
import FormInput from "../../../../components/Universal/FormInput.component";
import MemberFormValidation from "../../../../components/PagesComponents/Organizational/Management/Members/MemberFormValidation.component";
import { Helmet } from "react-helmet";

const Body = ({ staffAttendance, addMemberModal, setAddMemberModal }) => {
  const [matchHeightLeftRightContainer, setMatchHeightLeftRightContainer] =
    useState(); // State to store submitted values
  const suggestions = [
    "Apple",
    "Apple",
    "Banana",
    "Cherry",
    "Date",
    "Elderberry",
  ];
  const pichartContainerREef = useRef(null);
  useEffect(() => {
    setMatchHeightLeftRightContainer(pichartContainerREef.current.offsetHeight);
  }, []);
  return (
    <section className="staffsPage">
      <Helmet>
        <title>Staffs</title>
      </Helmet>
      <Modal isOpen={addMemberModal} onClose={() => setAddMemberModal(false)}>
        <Formik
          initialValues={{
            name: "",
            phone: "",
            email: "",
            designation: "",
            joiningDate: "",
            maritalStatus: "",
            workingField: "",
            gender: "",
            salary: "",
            reportingTo: "",
            bloodGroup: "",
            experience: "",
            experienceField: "",
            address: "",
            aadhaarNumber: "",
            photoCopy: null,
            signature: null,
            positionColor: "",
          }}
          validationSchema={MemberFormValidation} // Validation schema
          onSubmit={(values) => {
            console.log("Form Submitted:", values); // Log the values
            // setSubmittedValues(values); // Store the submitted values in state
          }}
        >
          {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => {
            return (
              <form onSubmit={handleSubmit} className="memberForm">
                <div className="memberAddFormLeft">
                  <h3 className="addNewMembersFormTitle">Add Members</h3>
                  <div className="addNewMembersLeftInputs">
                    {/* Additional fields or instructions can go here */}

                    <DropDownInput
                      type="color"
                      name="positionColor"
                      label="Position Color"
                      setFieldValue={(val) =>
                        setFieldValue("positionColor", val)
                      }
                      placeholder={"Choose Position Color"}
                      suggestionList={suggestions}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FileInput
                      name="photoCopy"
                      placeholder="Upload Image"
                      touched={touched}
                      label="Photo Copy"
                      setFieldValue={(file) => setFieldValue("photoCopy", file)}
                    />
                    <FileInput
                      name="signature"
                      placeholder="Upload Image"
                      label="Signature"
                      setFieldValue={(file) => setFieldValue("signature", file)}
                    />
                  </div>
                </div>

                <div className="memberAddFormRightInputs">
                  {/* Gender Inputs  */}
                  <div className="genderInputs">
                    <ToggleBtn
                      name="gender"
                      type={"radio"}
                      label="Male"
                      value={"male"}
                      setFieldValue={(val) => setFieldValue("gender", val)}
                      errors={errors}
                    />
                    <ToggleBtn
                      name="gender"
                      label="Female"
                      type={"radio"}
                      value={"Female"}
                      setFieldValue={(val) => setFieldValue("gender", val)}
                      errors={errors}
                    />
                    <ToggleBtn
                      name="gender"
                      label="Others"
                      type={"radio"}
                      value={"others"}
                      setFieldValue={(val) => setFieldValue("gender", val)}
                      errors={errors}
                    />
                  </div>
                  <div className="memberAddFormTextInputs">
                    <FormInput
                      type="text"
                      name="name"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your full name"
                      label="Name"
                      setFieldValue={(e) =>
                        setFieldValue("name", e.target.value)
                      }
                    />
                    <FormInput
                      label="Phone No"
                      type="number"
                      name="phone"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your phone number"
                      setFieldValue={(e) =>
                        setFieldValue("phone", e.target.value)
                      }
                    />

                    <FormInput
                      label="Email"
                      type="email"
                      name="email"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter your email address"
                      setFieldValue={(e) =>
                        setFieldValue("email", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="designation"
                      label="Designation"
                      setFieldValue={(val) => setFieldValue("designation", val)}
                      placeholder={"Choose designation"}
                      suggestionList={suggestions}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      touched={touched}
                    />

                    <DatePicker
                      label="Joining Date"
                      name="joiningDate"
                      setFieldValue={(val) => setFieldValue("joiningDate", val)}
                      placeholder={"Choose Joining Date"}
                      errors={errors}
                    />
                    <DropDownInput
                      name="maritalStatus"
                      label="Marital Status"
                      setFieldValue={(val) =>
                        setFieldValue("maritalStatus", val)
                      }
                      placeholder={"Choose Marital Status"}
                      suggestionList={["Married", "Unmarried"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="workingField"
                      label="Working field"
                      setFieldValue={(val) =>
                        setFieldValue("workingField", val)
                      }
                      placeholder={"Choose field of work"}
                      suggestionList={["testwork", "test2 work"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FormInput
                      label="Salary"
                      type="number"
                      name="salary"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter monthly pay scale (in INR)"
                      setFieldValue={(e) =>
                        setFieldValue("salary", e.target.value)
                      }
                    />
                    <DropDownInput
                      name="reportingTo"
                      label="Reporting to"
                      setFieldValue={(val) => setFieldValue("reportingTo", val)}
                      placeholder={"Choose supervisor"}
                      suggestionList={["person1", "person2"]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <DropDownInput
                      name="bloodGroup"
                      label="Blood group"
                      setFieldValue={(val) => setFieldValue("bloodGroup", val)}
                      placeholder={"Choose your blood group"}
                      suggestionList={[
                        "A+",
                        "A-",
                        "B+",
                        "B-",
                        "O+",
                        "O-",
                        "AB+",
                        "AB-",
                      ]}
                      errors={errors}
                      touched={touched}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FormInput
                      type="number"
                      touched={touched}
                      errors={errors}
                      name="experience"
                      label="Experience"
                      setFieldValue={(val) => setFieldValue("experience", val)}
                      placeholder={"Choose year of work experience"}
                    />
                    <DropDownInput
                      name="experienceField"
                      label="Experience field"
                      setFieldValue={(val) =>
                        setFieldValue("experienceField", val)
                      }
                      placeholder={"Choose field of experience"}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                      touched={touched}
                      suggestionList={[
                        "Internship",
                        "Entry Level",
                        "Junior",
                        "Mid-Level",
                        "Senior",
                        "Lead",
                        "Manager",
                        "Director",
                        "Vice President",
                        "C-Level (CEO, CTO, CFO, etc.)",
                      ]}
                    />
                    <FormInput
                      type="text"
                      touched={touched}
                      errors={errors}
                      name="address"
                      label="Address"
                      setFieldValue={(val) => setFieldValue("address", val)}
                      placeholder={"Enter your  full address, with pin"}
                    />
                    <FormInput
                      type="number"
                      touched={touched}
                      errors={errors}
                      name="aadhaarNumber"
                      label="Aadhaar number"
                      setFieldValue={(val) =>
                        setFieldValue("aadhaarNumber", val)
                      }
                      placeholder={"Enter your  aadhaar number"}
                    />
                    <button type="submit" className="memberFormSubmitBtn">
                      Verify
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </Modal>

      <PageHeader renderCustomElement={<PageHeaderCustomComponent />} />
      <div className="staffsHeadMemberContainContainer">
        <ul>
          {[...Array(10)].map((data, _key) => {
            return (
              <StaffsHeadCard
                image={TestProfileImage}
                name="Akhil Zabed"
                designation={"Hostel Super"}
              />
            );
          })}{" "}
        </ul>
      </div>

      <div className="staffsListAttendanceSection">
        <div
          className="allStaffsListContainer"
          style={{ height: `${matchHeightLeftRightContainer + 35}px` }}
        >
          <div className="staffsListContainerHeader">
            <div className="headerTitleAndAddMember">
              <h3>All Staffs</h3>
              <button
                className="staffsAddBtn"
                onClick={() => setAddMemberModal(!addMemberModal)}
              >
                ADD
              </button>
            </div>
            <div className="staffsCounting">10 persons</div>
          </div>
          <div className="allStaffsListScrollerContainer">
            <ul className="allStaffsListSection">
              {[...Array(10)].map((_, index) => (
                <MemberListCard
                  key={index}
                  image={profileImg}
                  name="Md Rejuwanul Karim"
                  profileId="SM0523019"
                  address="22 street, Kolkata 700016, West Bengal"
                />
              ))}
            </ul>
          </div>
        </div>
        <div
          className="departmentAttendanceContainer"
          ref={pichartContainerREef}
        >
          <div className="departmentalAttendanceContainer">
            {/* staffs attendance*/}

            <div className="staffsAttendancHeader">
              <h3>Department wise appearance</h3>
              <SelectFilter />
            </div>

            <PieChartComponent data={staffAttendance} />
            <div className="countPieChartData">
              <ul>
                {staffAttendance.map((entry) => {
                  const percentage = (
                    (entry.totalAttandence / entry.totalPerson) *
                    100
                  ).toFixed(2);

                  return (
                    <li
                      style={{
                        border: `2px solid ${entry.color}`,
                        background: entry.backgroundColor,
                      }}
                    >
                      <span style={{ color: entry.color }}>{entry.name}</span>
                      <span style={{ color: entry.color }}>{percentage}%</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
